<div class="landing-brands-wrapper box-swiper" aria-label="Chains section">
  <div class="landing-brands-header">
    <div class="landing-brands-navigation">
      <button #prevBtn mat-icon-button class="box-swiper-button-prev" aria-label="Previous chains">
        <mat-icon fontSet="material-icons-round">chevron_left</mat-icon>
      </button>
      <button #nextBtn mat-icon-button class="box-swiper-button-next" aria-label="Next chains">
        <mat-icon fontSet="material-icons-round">chevron_right</mat-icon>
      </button>
    </div>
  </div>

  <div [swiper]="swiperOptions" *ngIf="landingChains?.length > 0" aria-label="Chains section tiles">
    <div class="swiper-wrapper">
      <div class="swiper-slide" *ngFor="let chain of landingChains; let i = index" role="link" tabindex="0">
        <landing-chain
          [landingBrand]="chain"
          (selectBrand)="onSelectChain(chain, i)"
          class="hover-opacity hoverable-animated"
        ></landing-chain>
      </div>
    </div>
  </div>
</div>
